/**
 * Reports pages.
 */
import { generateTechTask } from '@/helpers/generated-tech-task'
import { RouteGroup } from '@/types/routing-types'


export default [
    {
        name: 'franchise-reporting',
        path: '/franchise-reporting',
        component: () => import('@/pages/FranchiseReporting/index.vue'),
        meta: {
            title: 'Franchise Reports',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.REPORTS
        }
    },
    {
        name: 'system-reports',
        path: '/system-reports',
        component: () => import('@/pages/SystemReports/index.vue'),
        meta: {
            title: 'System Reports',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.REPORTS
        }
    },
    generateTechTask('Custom Email Report', 'custom-email-report', RouteGroup.REPORTS),
    {
        name: 'social-reviews-report',
        path: '/social-reviews-report',
        component: () => import('@/pages/SocialReviewsReport/index.vue'),
        meta: {
            title: 'Social Reviews Report',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.REPORTS
        }
    }
]
